export default __webpack_public_path__ + "static/media/github-logo.77a97279.png";